import Link from 'next/link';
import styles from '@features/cms/components/categories/CategoryTilesBlock/components/CategoryTile/CategoryTile.styles';
import { ICategoryTile } from '@features/cms/typescript';
import Heading from '@components/Heading/Heading';
import { TServiceMap } from '@features/categories/typescript';
import sanitizeHtml from '@utils/sanitizeHtml';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  tile: ICategoryTile;
  serviceMap: TServiceMap;
};
const CategoryTile = ({
  tile,
  serviceMap
}: PropsType) => {
  const {
    image,
    name,
    categoryId,
    url: customUrl
  } = tile;
  const tileCustomUrl = customUrl || null;
  const url = categoryId && serviceMap[categoryId] ? serviceMap[categoryId] : tileCustomUrl;
  if (!url) return null;
  return <Link href={url}>
      <div sx={styles.container}>
        <div>
          <ResponsiveImage sx={styles.imageStyle} image={image} alt={name} />
        </div>
        <Heading h={4} headingType={4} mobile addSx={styles.heading} dangerouslySetInnerHTML={sanitizeHtml(name)} />
      </div>
    </Link>;
};
export default CategoryTile;